<template>
  <div class="container">
    <div class="bgoverlay">
      <div class="bg" :style="{ 'background-image': `url(${require('@/assets/images/newsbg.jpg')})` }"></div>
    </div>
    <div class="inner-pannel">
      <div class="pannel-content" style="padding-right:0;border-bottom:0;">
        <div class="pannel-content-box maxwidth-lg" style="padding:0;border-right:0;">
          <div class="content-page">
            <div class="ani animate__animated animate__fadeInUp">
              <div style="height:43px"></div>
              <el-row>
                <!-- <el-col :span="3">
                        <el-select v-model="value" @change="selectChange">
                            <el-option
                                v-for="item in $t('industryDynamics.options')"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col> -->
                <div style="padding: 0 50px 0 50px">
                  <el-col :span="24">
                    <el-input v-model="keyword" prefix-icon="el-icon-search"
                      :placeholder="$i18n.locale == 'zh' ? '关键词搜索' : 'search'" @input="search"></el-input>
                  </el-col>
                </div>
              </el-row>
              <div style="height:43px"></div>

              <div class="flex">
                <div class="time-line-box">
                  <div class="ball"></div>
                </div>
                <div v-for="item in yearList" style="width: calc(15% + 40px);">
                  <div :class="value == item ? 'time-text-box1 year-active' : 'time-text-box1'"
                    @click="changeYear(item)">
                    {{ item }}
                    <div :class="value == item ? 'ball-active time-ball' : 'time-ball'"></div>
                  </div>
                  <div class="time-line-box1"></div>
                </div>
                <div class="time-line-box" style="width: 100%;">
                  <div class="end-ball"></div>
                </div>
              </div>
              <div style="height:64px"></div>

              <div v-for="(item, index) in yearNewsList" :key="index" class="main-box">
                <div>
                  <div v-if="$i18n.locale == 'zh'" class="title">{{ item.releaseDate }} {{ item.source }}</div>
                  <div v-else class="title">{{ item.releaseDate }} {{ item.sourceEn }}</div>
                  <div v-if="$i18n.locale == 'zh'" class="content zh-font" @click="openDetail(item.url)">{{
                    item.title
                  }}</div>
                  <div v-else class="content en-font" @click="openDetail(item.urlEn)"> {{ item.titleEn }}</div>
                </div>
                <div style="height:20px"></div>
              </div>
              <div style="height:60px"></div>

              <div class="pagination">
                <el-pagination small :page-size="pagesize" :current-page.sync="pageno" layout="prev, pager, next"
                  :total="total" @current-change="handleCurrentChange">
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { request, get } from '../../utils/axios';

export default ({
  data() {
    return {
      value: '2022',
      pages: 0,
      currentPage: 1,
      keyword: "",
      dataList: [],
      orgData: [],

      yearList: [], //新闻年份列表
      yearNewsList: [],//年份新闻列表
      total: 0,
      pageno: 1,
      pagesize: 10
    }
  },
  created() {
    this.getNewsYear();
    return;
    if (this.value === '2022') {
      this.$t('industryDynamics.contents').forEach((res, index) => {
        if (index <= 9) {
          this.orgData.push(res)
        }
      })
      this.dataList = this.orgData.slice(0, 10)
      this.pages = this.orgData.length
    }
  },
  methods: {
    openDetail(href) {
      window.open(href, '_blank')
    },
    changeYear(year) {
      this.value = year;
      this.pageno = 1;
      // this.selectChange();
      this.getNewsList();
    },
    selectChange() {
      this.dataList = []
      this.keyword = ''
      this.currentPage = 1
      this.orgData = []
      if (this.value === '2022') {
        this.$t('industryDynamics.contents').forEach((res, index) => {
          if (index <= 9) {
            this.orgData.push(res)
          }
        })
        this.pages = this.orgData.length
        this.currentChange(this.currentPage)
      } else if (this.value === '2021') {
        this.$t('industryDynamics.contents').forEach((res, index) => {
          if (index > 9 && index <= 26) {
            this.orgData.push(res)
          }
        })
        this.pages = this.orgData.length
        this.currentChange(this.currentPage)
      } else if (this.value === '2020') {
        this.$t('industryDynamics.contents').forEach((res, index) => {
          if (index > 26) {
            this.orgData.push(res)
          }
        })
        console.log(this.orgData)
        this.pages = this.orgData.length
        this.dataList = this.orgData
      }
    },
    search() {
      this.pageno = 1;
      this.getNewsList();
      return;
      if (this.keyword == '') {
        this.selectChange()
        return
      }
      var _this = this
      var newData = []
      clearTimeout(this.timer)
      this.timer = setTimeout(function () {
        console.log(_this.keyword)
        _this.orgData.forEach(ele => {
          if (ele.title.indexOf(_this.keyword) != -1 || ele.content1.indexOf(_this.keyword) != -1) {
            newData.push(ele)
          }
        })
        _this.dataList = _this.getPage(newData)
      }, 500)
    },
    getPage(data) {
      if (data.length > 10) {
        this.pages = data.length
        return data.splice(0, 10)
      } else {
        this.pages = data.length
        return data
      }
    },
    currentChange(val) {
      if (this.orgData.length >= 10) {
        this.dataList = []
        this.orgData.forEach((res, index) => {
          if (index >= 10 * (val - 1) && index < (10 * val)) {
            this.dataList.push(res)
          }
        })
      }
    },

    // 获取新闻年份列表
    getNewsYear() {
      let params = {
        classifyid: 2
      }
      let url = "/newsapi/api/news/getyear/list";
      get(url, params).then((res) => {
        if (res.data.code == 200) {
          let yearList = res.data.data;
          this.yearList = yearList;
          if (yearList.length > 0) {
            let leastYear = yearList[0];
            this.value = leastYear;
            this.getNewsList(leastYear);
          }
        }
      })
    },

    // 获取新闻列表
    getNewsList() {
      let params = {
        year: this.value,
        classifyid: 2,
        pageno: this.pageno,
        pagesize: this.pagesize
      }
      if (this.keyword != "") {
        params.title = this.keyword;
      }
      let url = "/newsapi/api/news/gethome/list";
      get(url, params).then((res) => {
        if (res.data.code == 200) {
          let yearNewsList = res.data.data ? res.data.data : [];
          this.yearNewsList = yearNewsList;
          this.total = res.data.count ? res.data.count : 0;
        }
      })
    },

    handleCurrentChange(val) {
      this.pageno = val;
      this.getNewsList();
    }
  }
})
</script>

<style scoped>
/deep/ .el-input__inner {
  background: transparent;
  border-radius: 0;
  color: #ffffff;
  border-color: #707070;
}

/deep/ .el-select-dropdown__item .selected {
  color: #ED6D00;
}

.title {
  font-size: 18px;
  color: #ED6D00;
}

.inner-pannel::after {
  display: none;
}

.pannel-content {
  border-bottom: 0;
  padding-right: 0;
}

.pannel-content::before {
  display: none;
}

.pannel-content-box {
  border-right: 0;
  padding: 0px;
  padding-bottom: 50px;
}

.pannel-content-box::before {
  display: none;
}

.main-box {
  padding: 0 50px 0 50px;
}

.inner-pannel {
  min-height: 100%;
  padding-bottom: 54px;
  position: static;
  /* position: relative; */
  /* position: absolute; */
  width: 100%;
}

.pagination {
  text-align: center;
}

/deep/ .el-pagination button:disabled {
  background: transparent;
}

/deep/ .el-pager li {
    background: transparent;
    color: #FFFFFF;
}

/deep/ .el-pagination .btn-prev {
    background-color: unset;
    color: #FFFFFF;
}

/deep/ .el-pagination .btn-next {
    background-color: unset;
    color: #FFFFFF;
}

/deep/ .el-pager .number {
  /* color: #707070; */
}

/deep/ .el-pager li.active {
  color: #ED6D00;
}

/deep/ .el-pagination--small .btn-next {
  color: #ED6D00;
  background: transparent;
}

/deep/ .el-pagination--small .btn-prev {
  color: #ED6D00;
  background: transparent;
}

.flex {
  display: flex;
}

.time-line-box {
  width: 15%;
  border-bottom: 1px solid #ffffff;
  position: relative;
}

.time-text-box {
  height: 50px;
  color: #707070;
  position: relative;
  text-align: center;
  border-bottom: 1px solid #ffffff;
  cursor: pointer;
}


.time-line-box2 {
    width: 100%;
    border-bottom: 1px solid #ffffff;
    position: relative;
}

.time-text-box1 {
    height: 50px;
    color: #707070;
    position: relative;
    /* text-align: center; */
    border-bottom: 1px solid #ffffff;
    cursor: pointer;
}

.content {
  cursor: pointer
}

.year-active {
  color: #ED6D00;
}

.ball {
  position: absolute;
  width: 30px;
  height: 30px;
  left: -15px;
  bottom: -15px;
  background: #ED6D00;
  border-radius: 50%;
}

.end-ball {
  position: absolute;
  width: 30px;
  height: 30px;
  right: -15px;
  bottom: -15px;
  background: #ED6D00;
  border-radius: 50%;
}

.time-ball {
  position: absolute;
  width: 30px;
  height: 30px;
  left: 5px;
  bottom: -15px;
  background: #707070;
  border-radius: 50%;
}

.ball-active {
  background: #ED6D00;
}
</style>



// WEBPACK FOOTER //
// src/components/industryDynamics/industryDynamics.vue